import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../utils';
import omitProps from '../../../utils/omitProps';

const GetAllTicketsQuery = gql`
 query GetAllTickets(
   $first: Int,
   $last: Int,
   $nextCursor: String,
   $prevCursor: String,
   $districtId: Int,
   $departmentId: Int,
   $jobTicketNumber: String,
   $leaseId: Int,
   $operatorId: Int,
   $sorted: [TicketSortOptions]) {
    tickets(
      first: $first,
      last: $last,
      after: $nextCursor,
      before: $prevCursor,
      district_id: $districtId,
      department_id: $departmentId,
      job_ticket_number: $jobTicketNumber,
      lease_id: $leaseId,
      operator_id: $operatorId,
      sorted: $sorted) {
        count
        pages
        current_page
        pageInfo {
          startCursor
          hasPreviousPage
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            billing_revenue
            date {
              display
            }
            ticket_number {
              id
            }
            job {
              id
              job_number
              state
            }
            ticket_number {
              id
              number
              ticket {
                id
                state
                date {
                  iso8601
                }
              }
            }
            department {
              id
              name
            }
            district {
              id
              name
            }
            well {
              id
              name
              lease {
                id
                name
                operator {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
`;

const marshallData = ({ data, ownProps }) => {
  const allTickets = querySelector(data, '$.tickets.edges[*].node', []);
  const [pageInfo] = querySelector(data, '$.tickets.pageInfo', []);
  const [rowCount] = querySelector(data, '$.tickets.count', []);
  const [currentPage] = querySelector(data, '$.tickets.current_page', []);
  const [pages] = querySelector(data, '$.tickets.pages', []);
  const { loading } = data;
  return {
    ...ownProps,
    data,
    allTickets,
    pageInfo,
    rowCount,
    currentPage,
    loading,
    pages,
  };
};

const queryTicketData = graphql(GetAllTicketsQuery, {
  props: marshallData,
});

export const queryAllTicketsGQL = compose(
  queryTicketData,
  omitProps(['data']),
);
